<!-- This component simply let JavaScript explictly control the video tag and specifically when it enters the dom. Most attributes are a 1 to 1, with some variations. See Prop list. -->
<template>
    <video :class="classList ? classList : 'video'" :controls="controls" :controls-list="controlsList" :autoplay="autoplay" :muted="muted" :loop="loop" :data-object-fit="dataObjectFit">
        <source :src="src" :type="type">
        <source v-if="src2" :src2="src2" :type2="type2">
        <source v-if="src3" :src2="src3" :type2="type3">
    </video>
</template>
<script>
export default {
    props: {
        src: {
            required: true,
            type: String
        },
        src2: {
            type: String
        },
        src3: {
            type: String
        },
        type: {/* Type is for the video attribute. Not to be confused with the type property of the prop */
            type: String
        },
        type2: {/* Type is for the video attribute. Not to be confused with the type property of the prop */
            type: String
        },
        type3: {/* Type is for the video attribute. Not to be confused with the type property of the prop */
            type: String
        },
        classList: {
            type: String
        },
        controls: {
            type: Boolean
        },
        controlsList: {
            type: String
        },
        autoplay: {
            type: Boolean
        },
        muted: {
            type: Boolean
        },
        loop: {
            type: Boolean
        },
        poster: {
            type: String
        },
        preload: {
            type: String
        },
        dataObjectFit: {
            type: Boolean
        }
    }
}
</script>
